import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';
import 'whatwg-fetch';
import { wrapByLoader, wrapWithoutLoader } from "../../utils";
import { addToken } from './TokenActions';

const addTokensaga = (token:any) => {
    wrapByLoader(function* () {
        yield put(addToken(token));
    })
}
export default [takeLatest('ADD_TOKEN', addTokensaga)];
